import ViewPadrao from "../views/ViewPadrao";
import RelatorioVencimentoDocumentos from "../views/RelatorioVencimentoDocumentos";

export default {
  path: "documentos",
  component: ViewPadrao,
  children: [
    {
      path: "relatorio-vencimentos",
      name: "relatorio-vencimentos",
      component: RelatorioVencimentoDocumentos
    },
  ],
};
